import { Injectable } from "@angular/core";
import { MatSnackBar, MatSnackBarConfig } from "@angular/material/snack-bar";

import { ToasterSeverities } from "@enums/toaster-severities";
import { NotificationBarComponent } from "@features/+shared/notification-bar/notification-bar.component";

@Injectable({
  providedIn: "root",
})
export class NotificationService {
  constructor(private snackBar: MatSnackBar) {}

  show(
    severity: ToasterSeverities,
    message: string,
    information?: string
  ): void {
    const config: MatSnackBarConfig = {
      verticalPosition: "top",
      horizontalPosition: "center",
      duration: 5000,
      panelClass: this.getColorClassName(severity),
    };
    this.snackBar.openFromComponent(NotificationBarComponent, {
      data: { message, information },
      ...config,
    });
  }
  getColorClassName(severity: ToasterSeverities): Array<string> {
    switch (severity) {
      case ToasterSeverities.Success:
        return ["success-snackbar"];
      case ToasterSeverities.Warn:
        return ["warning-snackbar"];
      case ToasterSeverities.Error:
        return ["error-snackbar"];
      default:
        return ["info-snackbar"];
    }
  }
}
